export class ReportingStatusModel {
  readonly reportingStatusName: string;

  constructor(options: {
    reportingStatusName: string;
  }) {
    this.reportingStatusName = options.reportingStatusName;
  }
}
